import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import Screens from '..';
import AppBackgroundType from '../../utils/AppBackgroundType';
import QueryParamsProxy from '../../utils/queryParamProxy';
export var PAGE_SIZE = 8;
var TableGames = /*#__PURE__*/function (_Component) {
  function TableGames(props) {
    var _this;
    _classCallCheck(this, TableGames);
    _this = _callSuper(this, TableGames, [props]);
    _this._getLivePanelList = function () {
      var gameRooms = _this.props.gameRooms;
      var panelList = [];
      if (gameRooms && gameRooms.gameList[0] && gameRooms.gameList[0].games) {
        panelList = gameRooms.gameList[0].games;
      }
      panelList = panelList.filter(function (game) {
        return !game.IS_HIDDEN;
      });
      var pagedGames = new Array(Math.ceil(panelList.length / PAGE_SIZE)).fill().map(function (currentPage, index) {
        return panelList.slice(index * PAGE_SIZE, (index + 1) * PAGE_SIZE);
      });
      var pageNumber = 0;
      _this.setState({
        panelList: panelList,
        numColumn: 1,
        pagedGames: pagedGames,
        pageNumber: pageNumber
      });
    };
    _this._itemClickHandler = function (id) {
      _this.props.setGameId(id);
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, {
        gid: id
      });
    };
    _this.state = {
      panelList: [],
      numColumn: 0,
      pagedGames: [],
      pageNumber: 0
    };
    return _this;
  }
  _inherits(TableGames, _Component);
  return _createClass(TableGames, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._getLivePanelList();
      this.props.setAppBackground(AppBackgroundType.TABLE_GAMES);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.gameRooms !== this.props.gameRooms) {
        this._getLivePanelList();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setAppBackground(AppBackgroundType.NORMAL);
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render(_objectSpread(_objectSpread({}, this.state), this.props));
    }
  }]);
}(Component);
export { TableGames as default };